module.exports = __webpack_public_path__ + "img/microsoft.6c3b27b8.png";